import type {RouteRecordRaw} from "vue-router";

// O backend só exige [Authorize] no FinalidadeController (sem permissão por tela) e o catálogo
// EPermissao não tem código para Finalidade — rota e menu ficam abertos a qualquer usuário autenticado.
export const finalidadeRoutes: RouteRecordRaw[] = [
    {
        path: "/finalidade",
        name: "finalidade",
        meta: {authRequired: true},
        component: () => import("@/modules/finalidade/pages/PageFinalidade.vue")
    },
    {
        path: "/finalidade/matriz",
        name: "matriz-finalidade",
        meta: {authRequired: true},
        component: () => import("@/modules/finalidade/pages/PageMatrizFinalidade.vue")
    },
];
